"use strict";
exports.__esModule = true;
function getEnvironmentCDNPath(client) {
    if (!client) {
        return {
            production: "https://prod.artifi.io/",
            development: "./packages/",
            stage: "",
            integration: "//react.artifi.net/packages/",
            demo: "",
            integrationDev: './packages/',
            stageDev: ''
        };
    }
    if (client === 'staples') {
        return {
            production: "https://prod.artifi.io/",
            development: "./staples/",
            stage: "",
            integration: "//react.artifi.net/staples/",
            demo: "",
            integrationDev: './staples/',
            stageDev: ''
        };
    }
}
exports.getEnvironmentCDNPath = getEnvironmentCDNPath;
